<template>
  <div class="row pt-3" v-for="(propVal, property) in localValue" :key="property">
    <div class="col">
      <div class="form-floating">
        <form-field
          :element="propertyElements[property] ?? 'Form/TextInput.vue'"
          :property-elements="propertyElements"
          :label="propertyLabels[property] ?? trans(`models.${resourceType}.properties.${property}`)"
          :property-labels="propertyLabels"
          :name="`${name}-${property}`"
          :id="`${name}-${property}`"
          :resource-type="propertyResourceTypes[property] ?? null"
          :property-resource-types="propertyResourceTypes"
          :placeholder="propertyLabels[property] ?? trans(`models.${resourceType}.properties.${property}`)"
          :value="propVal ?? ''"
          :disabled="disabled"
          :choices="choices"
          @update:data="(updatedValue) => updateData(updatedValue, property)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormField from '@kanrisha/components/Form/FormField';
import { ref } from 'vue';

export default {
  components: {
    FormField,
  },
  props: {
    name: { type: String, default: () => '' },
    disabled: { type: Boolean, default: () => false },
    propertyElements: { type: Object, default: () => {} },
    propertyLabels: { type: Object, default: () => {} },
    propertyResourceTypes: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    value: { type: Object, default: () => {} },
    choices: { type: Object, default: () => {} },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValue = ref(props.value ?? {});

    const updateData = (val, property) => {
      localValue.value[property] = val;
      emit('update:data', localValue.value);
    };

    return {
      localValue,
      updateData,
    };
  },
};
</script>
